import Vue from 'vue'
import storage from 'store'
import expirePlugin from 'store/plugins/expire'
import { router } from '@/router'
import { ACCESS_TOKEN, USER_INFO, USER_VIP, LOCATION, CITY } from '@/store/mutation-types'
import {
  login,
  getMemberMe,
  ssoLogin,
  getCmccTokenConfig,
  reportCmccLog,
  cmccVerify,
  spLogin,
  hnLogin,
  getCmccSsoConfig,
  cmccSsoGetCodeSign,
  cmccSsoAuthenticate,
} from '@/api/login'
import { hidePhone, isWechat, isiOS } from '@/utils/common'
import { getJSConfig } from '@/api/wx'
import { Toast } from 'vant'

const user = {
  state: {
    token: '',
    info: null,
    vip: '',
    wxConfig: null,
    location: null,
    city: null,
    indexCategory: undefined,
    activityName: undefined,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_VIP: (state, vip) => {
      state.vip = vip
      storage.set(USER_VIP, vip)
    },
    SET_WXCONFIG(state, data) {
      state.wxConfig = data
    },
    SET_LOCATION(state, data) {
      state.location = data
      storage.set(LOCATION, data)
    },
    SET_CITY(state, data) {
      state.city = data
      storage.set(CITY, data)
    },
    SET_INDEX_CATEGORY(state, data) {
      state.indexCategory = data
    },
    SET_ACTIVITY_NAME(state, data) {
      state.activityName = data
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login({
          ...userInfo,
          browserSource: isWechat() ? 0 : 1,
        })
          .then((response) => {
            storage.set(ACCESS_TOKEN, response.token, 15 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', response.token)
            commit('SET_CITY', null)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    SSOLogin({ commit }, query) {
      return new Promise((resolve, reject) => {
        ssoLogin({
          ...query,
          browserSource: isWechat() ? 0 : 1,
        })
          .then((res) => {
            console.log(res)
            storage.set(ACCESS_TOKEN, res.token, 15 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    SpLogin({ commit }, query) {
      return new Promise((resolve, reject) => {
        spLogin({
          ...query,
          browserSource: isWechat() ? 0 : 1,
        })
          .then((res) => {
            console.log(res)
            storage.set(ACCESS_TOKEN, res.token, 15 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    HnLogin({ commit }, query) {
      return new Promise((resolve, reject) => {
        hnLogin({
          ...query,
          browserSource: isWechat() ? 0 : 1,
        })
          .then((res) => {
            console.log(res)
            storage.set(ACCESS_TOKEN, res.token, 15 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    CmccSsoLogin({ commit }, queryToken) {
      console.log('queryToken', queryToken)
      const callSsoSdk = (method, data) => {
        return new Promise((resolve, reject) => {
          method({
            data,
            success: resolve,
            error: reject,
          })
        })
      }

      const getSdkData = (config, keys) => {
        const key = keys.find((item) => config && config[item])
        return key ? config[key] : null
      }

      return new Promise((resolve, reject) => {
        getCmccSsoConfig({
          token: queryToken,
          // browserSource: isWechat() ? 0 : 1,
        })
          .then(async (config) => {
            if (!window.ssoLogin || !window.ssoLogin.showAuthPage || !window.ssoLogin.getSsoCode) {
              throw new Error('CMCC_SSO_SDK_NOT_READY')
            }

            console.log('config', config, window.ssoLogin)

            const params = {
              ...config,
              token: queryToken,
              authtype: '1',
            }
            console.log('params', JSON.stringify(params))
            console.log('ssoLogin', window.ssoLogin)
            let authRes
            try {
              authRes = await callSsoSdk(window.ssoLogin.showAuthPage, params)
              console.log('authRes', authRes)
            } catch (e) {
              console.log('showAuthPage err', e)
              reject(e)
              return
            }
            const userAuth = `${authRes.userAuth}`
            if (userAuth !== '1') {
              reject(new Error('CMCC_SSO_USER_CANCEL'))
            }

            const ssoRes = await cmccSsoGetCodeSign({
              token: queryToken,
              newToken: authRes.newToken,
              userAuth,
            })
            console.log('ssoRes', JSON.stringify(ssoRes))

            let codeRes
            try {
              codeRes = await callSsoSdk(window.ssoLogin.getSsoCode, {
                ...ssoRes,
                // token: queryToken,
                // newToken: authRes.newToken,
                // userAuth,
              })
            } catch (e) {
              console.log('getSsoCode err', e)
              reject(e)
              return
            }
            console.log('codeRes', codeRes)

            return cmccSsoAuthenticate({
              // ...query,
              // token: query.token,
              // newToken: authRes.newToken,
              // userAuth,
              ssoCode: codeRes.ssoCode,
              browserSource: isWechat() ? 0 : 1,
            })
          })
          .then((res) => {
            console.log('cmss auth res', res)
            if (!res) {
              return
            }
            storage.set(ACCESS_TOKEN, res.token, 15 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            commit('SET_CITY', null)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    CmccLogin(
      { commit },
      query = {
        mock: false,
      }
    ) {
      return new Promise((resolve, reject) => {
        if (isWechat()) {
          resolve()
          return
        }
        getCmccTokenConfig().then((config) => {
          if (query.mock) {
            config.mock = true
          }
          console.log('mock', config.mock)
          if (config.mock) {
            resolve()
            return
          }
          if (!isiOS()) {
            // 检测网络
            const connection = YDRZ.getConnection(config.appId)
            console.log(connection)
            if (connection.netType !== 'cellular') {
              reject(new Error('NETWORK_ERROR'))
              return
            }
          }
          YDRZ.getTokenInfo({
            data: config,
            success: (res) => {
              console.log('requestCmccToken success', res)
              if (res.code == '103000' || res.code == '000000') {
                reportCmccLog({
                  body: JSON.stringify(config),
                  result: JSON.stringify(res),
                  successFlag: true,
                  status: 0,
                })
                console.log('before verify')
                cmccVerify({
                  token: res.token,
                  userInformation: res.userInformation,
                })
                  .then((v) => {
                    console.log('verify succ', v)
                    if (v) {
                      resolve()
                      return
                    }
                    reportCmccLog({
                      body: JSON.stringify({
                        token: res.token,
                        userInformation: res.userInformation,
                      }),
                      result: JSON.stringify({
                        data: v,
                      }),
                      successFlag: false,
                      status: 0,
                    })
                    reject(new Error('VERIFY_FAIL'))
                  })
                  .catch((e) => {
                    console.log('verify err', e.message)
                    // reject(new Error(''))
                    reject(new Error('NETWORK_ERROR'))
                  })
                // resolve()
              } else {
                reportCmccLog({
                  body: JSON.stringify(config),
                  result: JSON.stringify(res),
                  successFlag: false,
                  status: 0,
                })
                // reject(new Error('获取CMCC TOKEN失败'))
                reject(new Error('NETWORK_ERROR'))
              }
            },
            error: (err) => {
              console.log('requestCmccToken error', err)
              reportCmccLog({
                body: JSON.stringify(config),
                result: JSON.stringify(err),
                successFlag: false,
                status: 0,
              })
              // reject(new Error(err.message))
              reject(new Error('NETWORK_ERROR'))
            },
          })
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getMemberMe()
          .then((res) => {
            console.log(res)
            res.hidePhone = hidePhone(res.phone)

            // 设置默认会员等级
            if (storage.get(USER_VIP)) {
              if (res.levels && res.levels.includes(storage.get(USER_VIP))) {
                commit('SET_VIP', storage.get(USER_VIP))
              } else if (res.levels.length > 0) {
                commit('SET_VIP', res.levels[0])
              }
            } else {
              const currentVip = res.levels.length > 0 ? res.levels[0] : undefined
              commit('SET_VIP', currentVip)
            }

            commit('SET_INFO', res)
            storage.set(USER_INFO, res)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_INFO', null)
        commit('SET_VIP', null)
        storage.remove(ACCESS_TOKEN)
        storage.remove(USER_INFO)
        storage.remove(LOCATION)
        storage.remove(CITY)
        storage.remove('openid')
        storage.remove('mina_openid')
        // setTimeout(() => {
        //   window.location.reload()
        // }, 100)
        resolve()
      })
    },

    // 获取微信地理位置
    GetLocation({ commit }) {
      return new Promise((resolve, reject) => {
        // 获取当前页面的url
        const url = location.href

        getJSConfig({ url }).then((res) => {
          const { appId, timestamp, nonceStr, signature } = res
          console.log(res)
          wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ['getLocation'],
          })
          wx.ready(() => {
            wx.getLocation({
              type: 'wgs84',
              success: (res) => {
                console.log('微信定位：')
                console.log(res)
                // const { latitude, longitude } = res
                commit('SET_LOCATION', res)
                resolve(res)
              },
              fail: function (err) {
                console.log(err)
                reject(err)
              },
            })
          })
        })
      })
    },
    LoginByToken({ commit, dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        storage.set(ACCESS_TOKEN, payload, 15 * 24 * 60 * 60 * 1000)
        commit('SET_TOKEN', payload)

        const res = await dispatch('GetInfo')
        resolve(res)
      })
    },
  },
}

export default user
